import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import Layout, { Main } from './Layout';
import { useLanguage } from '../../../context/language/language';
import { Button, Row, Space } from '../../common';
import {
  ClickAndCollectButton,
  ClickQuickAndCollectButton,
  HomeDeliveryButton
} from './Button';
import useDeliveryData from '../../common/hook/useDeliveryData';
import useDeliveryControlFlow from '../../common/hook/useDeliveryControlFlow';
import { DELIVERY_ADDRESS, SELECT_STORE, SELECT_STORE_TYPE, REDIRECT_TO_HOME, CHANGE_STORE_DIALOG, REDIRECT_TO_B2B } from '../../../constant/deliveryFlow';
import useResponsive from '../../../utils/responsive';
import {
  deliverySelectionModalSize,
  deliverySelectionMyModalSize
} from './modalSize';
import { trackPageLoad } from '../../../utils/adobeAnalytics';
import { useSite } from '../../../context/siteContext';
import {
  trackClickSelectDeliveryMethod,
  trackClickSelectDeliveryType
} from '../../../utils/eventTracking';
import Display from '../../common/Display';
import { getIsPhoenix, getStoreOpenTime } from '../../../utils/utils';
import useCustomerAddressList from '../../common/hook/useCustomerAddressList';
import { deliveryUpdateForm } from '../../../store/deliveryFlow/actions';
import { selectLoginState } from '../../../store/authentication/selector';
import { is1HrStore } from '../../../utils/useSpecialStore';
import { getActiveShippingAddress } from '../../common/hook/useShippingAddress';
import {
  deliveryFlowSetPreStack,
  setRedirectTo,
  setPendingDeliverySetting,
} from '../../../store/deliveryFlow/slices';
import { goToPath } from '../../../utils/useLocationPath';
import urlResolver from '../../../constant/urlPattern';

const isPhoenix = getIsPhoenix();

const useStyle = makeStyles((theme) => ({
  footer: {
    position: 'absolute',
    bottom: 0,
    backgroundColor: 'white',
    zIndex: 10,
    paddingBottom: theme.isMobile ? 12 : 24,
    paddingTop: 12,
    paddingLeft: 0,
    paddingRight: 0,
    width: 'calc(100vw)',
    left: 0,
    right: 0,
    margin: 'auto'
  },
  submitButton: {
    height: 44,
    marginRight: '10px',
    fontSize: '18px',
    fontFamily: 'LotusSmartHL',
    textTransform: 'none',
    padding: '8px 46px',
    borderRadius: '8px',
    color: 'white',
    '&disabled': {
      backgroundColor: '#B0EAE7',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '8px 46px',
    },
  },
}));

const SelectDeliveryType = (props) => {
  const word = useLanguage();
  const classes = useStyle();
  const deliveryData = useDeliveryData();
  const deliveryControl = useDeliveryControlFlow();
  const activeFlag = deliveryData.activeDeliveryType === 'SFL' && deliveryData.formHadData;
  const activeWidgetB2B = _.get(deliveryData, 'startB2BActive', false);
  const warningStoreOpenTime = getStoreOpenTime();
  const { isMobile, isTablet } = useResponsive();
  const { addressList, defaultAddress, getAddress } = useCustomerAddressList();
  const { activeShippingAddress, hasActiveShippingAddress } = getActiveShippingAddress(deliveryControl?.stateFlow);
  const { ThSite, MySite } = useSite();
  const defaultState = warningStoreOpenTime.isClose ? 'HD' : 'OD';
  const [selectState, setSelectState] = React.useState(defaultState);
  const defaultStoreType = !deliveryData.isCompleteForm ? "go_fresh" : deliveryData.disableGoFresh
    ? 'hyper'
    : deliveryData.disableHyper
      ? 'go_fresh'
      : !_.isEmpty(deliveryData?.currentStore?.storeType)
        ? is1HrStore(isPhoenix ? deliveryData?.currentStore?.storeCode : deliveryData?.currentStore?.id)
          ? 'go_fresh'
          : deliveryData?.currentStore?.storeType
        : 'go_fresh';
  const [selectStoreType, setSelectStoreType] = React.useState(defaultStoreType);
  const dispatch = useDispatch();
  const [nextPage, setNextPage] = React.useState(DELIVERY_ADDRESS);
  const isLogin = useSelector(selectLoginState);
  const isDifferentStoreTypeHasDefaultAddress = deliveryData?.fromDifferentStoreType && deliveryData?.formData?.shippingAddress?.isDefault;
  const disableOndemandBtn = () => warningStoreOpenTime.isClose || deliveryData.disableOnDemand;
  const canClickOndemandBtn = () => !warningStoreOpenTime.isClose && !deliveryData.disableOnDemand;
  const getWidth = () => {
    if (isTablet) {
      return MySite ? deliverySelectionMyModalSize.tablet.width : deliverySelectionModalSize.tablet.width;
    }
    return MySite ? deliverySelectionMyModalSize.desktop.width : deliverySelectionModalSize.desktop.width;
  };

  const handlerConfirmMobileList = () => {
    switch (selectState) {
      case 'OD':
          if (selectStoreType) {
            const isFromWidgetGF = deliveryData?.fromWidget && selectStoreType === 'go_fresh';
            if (deliveryData?.activeDeliveryMethod?.includes('HLE') && (isFromWidgetGF || !deliveryData?.fromWidget)) {
              dispatch(setRedirectTo(REDIRECT_TO_HOME));
              dispatch(setPendingDeliverySetting(`${nextPage}.${selectStoreType}.OD.HD`));
              dispatch(deliveryFlowSetPreStack({ stack: [CHANGE_STORE_DIALOG], cmd: true }));
            } else {
              deliveryData.updateForm('filter', { storeType: selectStoreType });
              props.onNext(`OD.${selectStoreType}`, isDifferentStoreTypeHasDefaultAddress ? SELECT_STORE : nextPage);
            }
          } else {
            props.onNext('OD', isDifferentStoreTypeHasDefaultAddress ? SELECT_STORE : nextPage);
          }
          trackClickSelectDeliveryType('OD');
        break;
      case 'HD':
      case 'B2B':
      case 'HDND':
          if (activeWidgetB2B) {
            if (deliveryData.activeDeliveryMethod === "B2B") {
              goToPath(urlResolver('b2bHome'));
            } else {
              deliveryControl.startB2B(REDIRECT_TO_B2B);
            }
          } else {
            props.onNext('HD', isDifferentStoreTypeHasDefaultAddress ? SELECT_STORE : nextPage);
          }
          trackClickSelectDeliveryMethod('SFL', activeWidgetB2B ? 'B2B' : 'HD');
          break;
      case 'CC':
      case 'CCND':
          props.onNext('CC', SELECT_STORE);
          trackClickSelectDeliveryMethod('SFL', 'CC');
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (deliveryData.activeDeliveryType) {
      if (deliveryData.activeDeliveryType === 'SFL') {
        setSelectState(deliveryData.activeDeliveryMethod);
      } else {
        if (warningStoreOpenTime.isClose) {
          setSelectState('HD');
        } else {
          setSelectState(deliveryData.activeDeliveryType);
        }
      }
    }
  }, [deliveryData.activeDeliveryType]);

  useEffect(() => {
    if (deliveryData.hideOnDemand && selectState.includes('OD')) {
      if (deliveryData?.activeDeliveryMethod === null || deliveryData?.activeDeliveryMethod?.includes('HD')) {
        setSelectState('HD');
      } else {
        setSelectState('CC');
      }
    }
  }, [deliveryData.hideOnDemand, selectState]);

  useEffect(() => {
    if (ThSite) {
      trackPageLoad('Schedule for Later Delivery Method');
    } else {
      trackPageLoad('Delivery Method');
    }
    if (warningStoreOpenTime.isClose) {
      if (deliveryData?.activeDeliveryMethod?.includes('HD')) {
        setSelectState('HD');
      }
    }
  }, []);

  useEffect(() => {
    if (isLogin) {
      if (addressList) {
        const changeMethod = _.get(deliveryData, 'storeWithoutArea.changeMethod', false);
        if (!changeMethod) {
          if (hasActiveShippingAddress) {
            dispatch(deliveryUpdateForm('shippingAddress', activeShippingAddress));
          } else if (defaultAddress) {
            dispatch(deliveryUpdateForm('shippingAddress', defaultAddress));
          }
        }
        setNextPage(defaultAddress ? SELECT_STORE : DELIVERY_ADDRESS);
      } else if (addressList !== undefined) {
        getAddress();
      }
    }
  }, [addressList]);

  const getActiveBtnNextDay = () => {
    if (activeWidgetB2B) {
      return deliveryData.activeDeliveryMethod?.includes('B2B') && deliveryData?.formHadData;
    }
    return deliveryData.activeDeliveryMethod?.includes('HD') && activeFlag;
  };

  return (
    <Layout
      title={word('DeliveryAddress.Type.Options')}
      backButtonShown={deliveryControl.stackSize > 1}
      onBack={props.onBack}
      onClose={props.onClose}
      bottomSpace={0}
      width={getWidth()}
      height={isTablet ? deliverySelectionModalSize.tablet.height : deliverySelectionModalSize.desktop.height}
      isDefaultModalSize={false}
    >
      <Main noPaddingX>
        <Display show={isMobile}>
          <Display show={!deliveryData.hideOnDemand}>
            <ClickQuickAndCollectButton
              id="delivery-method-on-demand-btn"
              active={selectState.includes('OD') && canClickOndemandBtn()}
              onClick={(value) => {
                if (canClickOndemandBtn()) {
                  setSelectState(value);
                }
              }}
              disabled={disableOndemandBtn()}
              selectState={selectState}
              selectStoreType={selectStoreType}
              setSelectStoreType={setSelectStoreType}
            />
          </Display>
          <HomeDeliveryButton
            id="delivery-type-home-delivery-btn"
            active={selectState.includes('HD') || selectState.includes('B2B')}
            onClick={(value) => {
              setSelectState(value);
            }}
          />
          <ClickAndCollectButton
            id="delivery-type-click-and-collect-btn"
            active={selectState.includes('CC')}
            onClick={(value) => {
              setSelectState(value);
            }}
          />
          <div style={{ height: 65 }} />
          <Grid
            container
            spacing={0}
            className={classes.footer}
            style={{ borderTop: 'solid 1px #E0E0E0', paddingTop: 12 }}
          >
            <Grid item xs={12} style={{ textAlign: 'center', paddingLeft: 12, paddingRight: 12 }}>
              <Button
                className={classes.submitButton}
                onClick={() => handlerConfirmMobileList()}
                id="confirm-address-btn"
              >
                {word('General.Confirm')}
              </Button>
            </Grid>
          </Grid>
        </Display>
        <Display show={!isMobile}>
          <Row>
            <Display show={!deliveryData.hideOnDemand}>
              <ClickQuickAndCollectButton
                id="delivery-method-on-demand-btn"
                active={deliveryData.currentSetting.includes('OD') && canClickOndemandBtn()}
                onClick={() => {
                  if (canClickOndemandBtn()) {
                    const siteState = ThSite ? SELECT_STORE_TYPE : DELIVERY_ADDRESS;
                    props.onNext('OD', isDifferentStoreTypeHasDefaultAddress ? SELECT_STORE : ThSite ? siteState : nextPage);
                    trackClickSelectDeliveryType('OD');
                  }
                }}
                disabled={disableOndemandBtn()}
              />
              <Space line={0.8} />
            </Display>
            <HomeDeliveryButton
              id="delivery-type-home-delivery-btn"
              active={getActiveBtnNextDay()}
              onClick={() => {
                const changeMethod = _.get(
                  deliveryData,
                  'storeWithoutArea.changeMethod',
                  false
                );
                if (activeWidgetB2B) {
                  if (deliveryData?.activeDeliveryMethod?.includes('B2B')) {
                    goToPath(urlResolver('b2bHome'));
                  } else {
                    deliveryControl.startB2B(REDIRECT_TO_B2B);
                  }
                } else if (changeMethod) {
                  props.onNext('HD', SELECT_STORE);
                } else {
                  props.onNext('HD', isDifferentStoreTypeHasDefaultAddress ? SELECT_STORE : nextPage);
                }
                trackClickSelectDeliveryMethod('SFL', deliveryData?.startB2BActive ? 'B2B' : 'HD');
              }}
            />
            <Space line={0.8} />
            <ClickAndCollectButton
              id="delivery-type-click-and-collect-btn"
              active={!!(deliveryData.activeDeliveryMethod?.includes('CC') && activeFlag)}
              onClick={() => {
                props.onNext('CC', SELECT_STORE);
                trackClickSelectDeliveryMethod('SFL', 'CC');
              }}
            />
          </Row>
        </Display>
      </Main>
    </Layout>
  );
};

SelectDeliveryType.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  onClose: PropTypes.func,
};

SelectDeliveryType.defaultProps = {
  onBack: () => false,
  onNext: () => false,
  onClose: () => false,
};

export default SelectDeliveryType;
